import React from "react";
import {
  Box,
  Card,
  Grid,
  Skeleton,
  Stack,
  Divider,
  Button,
} from "@mui/material";

export default function ProfileSkeleton() {
  return (
    <Box sx={{ width: "100%" }}>
      {/* ================= HERO SECTION ================= */}
      <Card sx={{ p: 4, mb: 4 }}>
        <Stack spacing={2}>
          <Skeleton width={260} height={34} />
          <Skeleton width={420} height={22} />

          <Grid container spacing={4} sx={{ mt: 2 }}>
            <Grid xs={12} md={4}>
              <Skeleton width={80} height={18} />
              <Skeleton width={140} height={30} />
            </Grid>

            <Grid  xs={12} md={4}>
              <Skeleton width={200} height={18} />
              <Skeleton width={220} height={28} />
            </Grid>
          </Grid>

          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            <Skeleton variant="rectangular" width={160} height={42} />
            <Skeleton variant="rectangular" width={160} height={42} />
          </Stack>
        </Stack>
      </Card>

      {/* ================= DETAILS GRID ================= */}
      <Grid container spacing={3}>
        {/* Account Details */}
        <Grid  xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Skeleton width={180} height={26} sx={{ mb: 2 }} />

            <Skeleton width={160} height={18} />
            <Skeleton width={260} height={24} sx={{ mb: 2 }} />

            <Skeleton width={200} height={20} />
            <Skeleton width={180} height={20} sx={{ mt: 1 }} />
          </Card>
        </Grid>

        {/* Profile Card */}
        <Grid  xs={12} md={6}>
          <Card sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between">
              <Skeleton width={120} height={26} />
              <Skeleton variant="rectangular" width={80} height={30} />
            </Stack>

            <Divider sx={{ my: 2 }} />

            {[1, 2, 3, 4].map((_, index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ mb: 1 }}
                key={index}
              >
                <Skeleton width={120} height={18} />
                <Skeleton width={180} height={18} />
              </Stack>
            ))}
          </Card>
        </Grid>
      </Grid>

      {/* ================= PREFERENCES SECTION ================= */}
      <Box sx={{ mt: 5 }}>
        <Skeleton width={240} height={28} />
        <Skeleton width={420} height={20} sx={{ mb: 3 }} />

        <Grid container spacing={3}>
          {[1, 2, 3].map((_, index) => (
            <Grid  xs={12} md={4} key={index}>
              <Card sx={{ p: 3 }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton width={120} height={20} />
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
